import React, {Component} from 'react'
import {Select} from 'antd'
import PropTypes from 'prop-types'
import {ORDERS_SORT} from '../../helpers/orderFilters'

class SortOrders extends Component {
    _handleChange = (value) => {
        const {field, onSelected} = this.props
        onSelected(field, JSON.parse(value))
    }

    render() {
        const defaultSelect = JSON.stringify(ORDERS_SORT[0].value)

        return (
            <div className='SortOrders'>
                <span className='Label mr-3'>Sắp xếp theo:</span>
                <Select defaultValue={defaultSelect} onChange={this._handleChange}>
                    {
                        ORDERS_SORT.map(option => {
                            const {name, value} = option
                            const valueStr = JSON.stringify(value)

                            return <Select.Option key={valueStr} value={valueStr}>{name}</Select.Option>
                        })
                    }
                </Select>
            </div>
        )
    }
}

SortOrders.propTypes = {
    field: PropTypes.string.isRequired,
    onSelected: PropTypes.func.isRequired,
}

export default SortOrders
